export enum FeedbackType {
    NONE,
    OPTION,
    DEFAULT,
    CORRECT
  }